import { render, staticRenderFns } from "./EditLesson.vue?vue&type=template&id=d3f99592&"
import script from "./EditLesson.vue?vue&type=script&lang=ts&"
export * from "./EditLesson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports